import { Box, Select, SimpleGrid, Text } from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import OsVersionNames from '../../utils/OsVersionMapping.json';

function OsVersions({ AppStore, onOsVersionChange, preFilledData }) {

  const [minVersion, setMinVersion] = useState('');
  const [maxVersion, setMaxVersion] = useState('');

  const osVersionNames =
    AppStore === 'itunes'
      ? OsVersionNames.mobileOsVersionNames.iOS
      : AppStore === 'google_play'
      ? OsVersionNames.mobileOsVersionNames.Android
      : [];

  // Convert the version strings to numbers for comparison
  const getVersionValue = (version) => parseFloat(version);

  useEffect(() => {
    const osArray = preFilledData?.user_os;
  
    if (osArray?.length > 0 && typeof osArray[0] === 'string') {
      const osString = osArray[0];
  
      if (osString.includes("and_above")) {
        const minMatch = osString.match(/\d+\.\d+/);
        if (minMatch) {
          setMinVersion(minMatch[0]);
          setMaxVersion("None");
        }
        return;
      }
  
      const match = osString.match(/\d+\.\d+/g);
      if (match) {
        let [min, max] = [match[0], match[1]];
        setMinVersion(min);
        setMaxVersion(max);
        return;
      }
  
    } else {
      setMinVersion(AppStore === 'itunes' ? '2.0' : '1.0');
      setMaxVersion(AppStore === 'itunes' ? '14.4' : 'None');
    }
  }, [preFilledData, AppStore]);
  
  
  useEffect(() => {
    if (minVersion && maxVersion !== undefined && AppStore) {
      onOsVersionChange(minVersion, maxVersion, AppStore);
    }
  }, [AppStore, minVersion, maxVersion]);
  

  // Handler to update parent with min and max values
  const handleMinChange = (e) => {
    const value = e.target.value;
    setMinVersion(value);

    // Reset max version if the new min version is higher than the previous max version
    if (getVersionValue(value) > getVersionValue(maxVersion)) {
      console.log(value)
        setMaxVersion(value);
    }

    // Trigger onOsVersionChange after the state is updated
    onOsVersionChange(value, maxVersion, AppStore);
  };

  const handleMaxChange = (e) => {
    const value = e.target.value;
    setMaxVersion(value);

    // Trigger onOsVersionChange after the state is updated
    onOsVersionChange(minVersion, value, AppStore);
  };

  return (
    <Box>
      <SimpleGrid columns={2} spacing={4}>
        {/* Min Select */}
        <Box>
          <Text fontWeight={'bold'} fontSize={'14px'}>
            Min.
          </Text>
          <Select size={'sm'} borderRadius={'md'} value={minVersion} onChange={handleMinChange}>
            {/* Render options dynamically */}
            {Object.keys(osVersionNames).map((version) => {
              // Disable the options that are greater than the selected maxVersion
              const isDisabled = maxVersion && getVersionValue(version) > getVersionValue(maxVersion);
              return (
                <option key={version} value={version} disabled={isDisabled}>
                  {AppStore === 'google_play' ? `${version} ${osVersionNames[version]}` : version}
                </option>
              );
            })}
          </Select>
        </Box>

        {/* Max Select */}
        <Box>
          <Text fontWeight={'bold'} fontSize={'14px'}>
            Max.
          </Text>
          <Select size={'sm'} borderRadius={'md'} value={maxVersion} onChange={handleMaxChange}>
            <option value="None">None</option>
            {/* Render options dynamically */}
            {Object.keys(osVersionNames).map((version) => {
              // Disable the options that are less than the selected minVersion
              const isDisabled = minVersion && getVersionValue(version) < getVersionValue(minVersion);
              return (
                <option key={version} value={version} disabled={isDisabled}>
                  {AppStore === 'google_play' ? `${version} ${osVersionNames[version]}` : version}
                </option>
              );
            })}
          </Select>
        </Box>
      </SimpleGrid>
    </Box>
  );
}

export default OsVersions;
